import { api } from '@/lib/api';

/** V4.9.25 — Category-group dashboards (the new Refund / Reprint & Replacement /
 *  Other issues / Request sidebar tabs). Read-only; reuses the main dashboard's
 *  metrics, broken down by sub-category × geo. */

export interface GroupMetrics {
  open: number;
  created_today: number;
  breached: number;
  under_2h: number;
  under_24h: number;
  approvals_waiting: number;
}

export interface GroupCategoryRow extends GroupMetrics {
  code: string;
  label: string;
}

export interface GroupGeoRow extends GroupMetrics {
  geo: string;
  label: string;
  store_codes: string[];
}

export interface CategoryGroupStats {
  group: string;
  categories: { code: string; label: string }[];
  geos: { geo: string; label: string; store_codes: string[] }[];
  by_category: GroupCategoryRow[];
  by_geo: GroupGeoRow[];
  matrix: Record<string, Record<string, GroupMetrics>>; // matrix[geo][categoryCode]
  server_time: string;
}

export const categoryGroupsApi = {
  stats: (groupKey: string) => api.get<CategoryGroupStats>(`/dashboard/category-group/${groupKey}`)
};

/** The 4 tabs — key (API + route), title, optional subtitle, and the category
 *  codes the tab scopes to (mirrors the backend grouping). */
export interface CategoryGroupTab {
  key: string;
  path: string;
  title: string;
  subtitle?: string;
  codes: string[];
}

export const CATEGORY_GROUP_TABS: CategoryGroupTab[] = [
  { key: 'refund', path: '/refund', title: 'Refund', codes: ['A1', 'A2'] },
  { key: 'reprint-replacement', path: '/reprint-replacement', title: 'Reprint & Replacement', codes: ['A3', 'A4'] },
  { key: 'other-issues', path: '/other-issues', title: 'Other issues', subtitle: 'Service & Disputes', codes: ['A5', 'A6', 'A7'] },
  { key: 'request', path: '/request', title: 'Request', subtitle: 'Sales & Inquiries', codes: ['B1', 'B2', 'B3', 'B4'] }
];
